import { defineAsyncComponent } from 'vue';

const Organization = defineAsyncComponent(
  () => import('@/views/Organization/Organization.vue')
);

export default Organization;
